import React, { Component } from "react";
class Payment3DCancel extends Component {
    render() {
        return (<div className="container">
            <h1>Cancel</h1>
        </div>);
    }
}
export default Payment3DCancel;